export default __webpack_public_path__ + "static/media/ic_placeholderModel.59905a33.svg";